import { EditOfferPopupModal } from 'features/discount-code/components/modal/edit-offer-popup-modal';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from 'routes/constants';

export const EditOfferPopupEditView = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  if (!id) return null;

  const closeModal = () => {
    navigate(ROUTES.DISCOUNT_CODE_OFFER_POPUP);
    document.body.style.overflow = 'visible';
  };

  return (
    <EditOfferPopupModal id={id} onClose={closeModal} onSuccess={closeModal} />
  );
};
